<div class="desempenho-instrumento-mobile">
  <!-- Loading State -->
  <div class="loading-state" *ngIf="isLoading">
    <div class="loading-spinner">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Carregando...</span>
      </div>
    </div>
    <h4 class="loading-title">Carregando dados de avaliação...</h4>
    <p class="loading-text">Aguarde enquanto buscamos as informações dos alunos e instrumentos.</p>
  </div>

  <app-empty-state
    *ngIf="semCalendario && !isLoading"
    imagem="assets/images/professor-nao-possui-turmas.png"
    titulo="Esta turma não possui calendário escolar definido"
    descricao="Procure o(a) secretário(a) do seu estabelecimento de ensino para preencher estas informações no Cadastro de Turmas.">
  </app-empty-state>

  <app-empty-state
    *ngIf="!semCalendario && semPeriodoAvaliativo && !isLoading"
    imagem="assets/images/professor-nao-possui-turmas.png"
    titulo="Este componente curricular não possui as datas inicial e final definidas para o período avaliativo"
    descricao="Procure o(a) secretário(a) do seu estabelecimento de ensino para preencher estas informações no Cadastro de Turmas.">
  </app-empty-state>

  <div *ngIf="!isLoading && !semCalendario && !semPeriodoAvaliativo && !hasItensList && filtroAtivo" class="border border-gray-200 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 shadow-sm mt-4">
    <app-empty-state
      icone="notebook-pen"
      tema="yellow">
      <div class="text-sm text-slate-600 dark:text-slate-400 max-w-sm mx-auto flex flex-col gap-4">
        <p>Nenhum aluno encontrado para o filtro selecionado.</p>
      </div>
    </app-empty-state>
  </div>

  <div *ngIf="!isLoading && !semCalendario && !semPeriodoAvaliativo && !hasItensList && !filtroAtivo" class="border border-gray-200 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 shadow-sm mt-4">
    <app-empty-state
      icone="users"
      titulo="Nenhum aluno encontrado"
      descricao="Não há alunos matriculados para este período avaliativo."
      tema="slate">
    </app-empty-state>
  </div>

  <div *ngIf="!isLoading && hasItensList && !hasColunas" class="border border-gray-200 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 shadow-sm mt-4">
    <app-empty-state
      icone="notebook-pen"
      tema="yellow">
      <div class="text-sm text-slate-600 dark:text-slate-400 max-w-sm mx-auto flex flex-col gap-4">
        <p>Ainda não há instrumentos de avaliação cadastrados para o componente selecionado.</p>
        <p>Clique no botão <strong class="font-bold text-slate-800 dark:text-slate-200">+Instrumento</strong> acima e cadastre um novo instrumento.</p>
      </div>
    </app-empty-state>
  </div>

  <div *ngIf="!isLoading && hasItensList && hasColunas && !hasAvaliacoes" class="border border-gray-200 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 shadow-sm mt-4">
    <app-empty-state
      icone="clipboard-check"
      titulo="Nenhum registro de avaliação encontrado"
      descricao="Os instrumentos estão cadastrados, mas ainda não há registros de avaliação para os alunos."
      tema="slate">
    </app-empty-state>
  </div>

  <!-- Lista de alunos em cards - Layout intuitivo -->
  <div class="alunos-cards-container" *ngIf="!isLoading && hasAvaliacoes">
    <div class="aluno-card" *ngFor="let linha of linhas; trackBy: trackByEnturmacao">
      <div class="aluno-card-header">
        <div class="aluno-info">
          <div class="aluno-numero-badge">{{ linha.enturmacao.numeroChamada }}</div>
          <div class="flex flex-col min-w-0 items-start gap-1">
            <div class="aluno-nome">{{ linha.enturmacao.matricula.nomeSocial || linha.enturmacao.matricula.nome }}</div>
            <app-label-situacao-matricula
              *ngIf="getSituacaoMatriculaBadge(linha)"
              [situacao]="getSituacaoMatriculaBadge(linha)">
            </app-label-situacao-matricula>
            <div *ngIf="getErroDaLinha(linha)" class="w-full animate-fade-in mt-1.5 pr-2">
              <div class="px-2.5 py-2 bg-red-50 border border-red-100 text-red-600 rounded text-[13px] text-left font-medium dark:bg-red-900/20 dark:border-red-800 dark:text-red-400 shadow-sm leading-snug">
                {{ getErroDaLinha(linha) }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="avaliacoes-section" *ngIf="colunas && colunas.length > 0">
        <div class="avaliacoes-grid">
          <div class="avaliacao-item" *ngFor="let coluna of colunas; let colIndex = index; trackBy: trackByColuna">
            <div class="avaliacao-input-wrapper">
              <ng-container *ngIf="linha.notas && linha.notas[colIndex]; else notaVazia">
                <app-input-nota
                  [nota]="linha.notas[colIndex]"
                  [coluna]="coluna"
                  [configuracaoAvaliacao]="configuracaoAvaliacao"
                  [disabled]="!hasPermissionsToEdit"
                  [mostrarParecer]="showParecerMethod()"
                  [mostrarCha]="hasAnyConfiguracaoCha"
                  [bloquearChaExameFinal]="true"
                  (notaSalva)="onSalvar($event)"
                  (openParecer)="onShowParecer($event)"
                  (openCha)="onShowCHA($event)"
                  (openAvaliacaoDescritiva)="onShowAvaliacaoDescritiva($event)">
                </app-input-nota>
              </ng-container>
              <ng-template #notaVazia>
                <app-input-nota
                  [disabled]="!hasPermissionsToEdit"
                  [configuracaoAvaliacao]="configuracaoAvaliacao">
                </app-input-nota>
              </ng-template>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
